import PLAN_NAME from 'constants/plan.const';

const salonSubscription = (hasBilling, pricingPlan) =>
  !hasBilling || pricingPlan === PLAN_NAME.essential || pricingPlan === '' || (hasBilling && pricingPlan === PLAN_NAME.essential) || (hasBilling && pricingPlan === '');

export default salonSubscription;
